import React from 'react'

export default function Loading({ style, fullPage, submitButtons, color, ...wrapperProps }) {

  style = {
    ...style,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  }

  if(fullPage) {
    style.marginTop = '15vh'
  } else if(submitButtons) {
    style.marginRight = 60
  }

  return (
    <div style={style} {...wrapperProps}>
      <div className="lds-ripple">
        <div  style={color ? { borderColor: color } : {}}></div>
        <div style={color ? { borderColor: color } : {}}></div>
      </div>
    </div>
  )
}
